import { useParams } from 'react-router';

import { VoucherProvider } from '../../context/VoucherProdiver';

import { VoucherBanner } from '../../components/VoucherBanner';
import { VoucherInfo, VoucherRules } from '../../components/VoucherInfo';
import { VoucherNav } from '../../components/VoucherNav';
import { VoucherOverview } from '../../components/VoucherOverview';
import { VoucherOrderInfo } from '../../components/VoucherOrderInfo';
import { VoucherComments } from '../../components/VoucherInfo/VoucherComments';
import { VoucherActionLogs } from '../../components/VoucherInfo/VoucherActionLogs';

const VoucherDetail = () => {
  const { id } = useParams();

  if (!id) return null;

  return (
    <VoucherProvider id={id}>
      <VoucherNav />
      <VoucherBanner />
      <VoucherOverview />
      <VoucherOrderInfo />
      <VoucherInfo />
      <VoucherRules />
      <VoucherComments />
      <VoucherActionLogs />
    </VoucherProvider>
  );
};

export default VoucherDetail;
